// Unpublished Work © 2021-2024 Deere & Company.

import t from 'tcomb';
import {AddressComponent} from './customer-address';
import {KeyValueList} from '../key-value-list';
import {TaxId} from './tax-id';
import {PrivacyPolicy} from './privacy-policy';
import {isFeatureToggled} from '../../../services/feature-toggles';

export const DomainData = t.struct({
    addressComponent: AddressComponent,
    allPrivacyPolicies: t.list(PrivacyPolicy),
    allTaxIds: t.list(TaxId),
    countries: KeyValueList,
    generations: KeyValueList,
    preferredLanguageList: KeyValueList,
    prefixes: KeyValueList,
    selectedValues: t.struct({
        country: t.String
    }),
    countryStatesList: KeyValueList
}, {
    defaultProps: {
        allPrivacyPolicies: [],
        allTaxIds: [],
        addressComponent: new AddressComponent({}),
        countries: [],
        preferredLanguageList: [],
        generations: [],
        prefixes: [],
        selectedValues: {
            country: ''
        },
        countryStatesList: []
    },
    name: 'DomainData',
    strict: true
});

DomainData.prototype.getValueFromId = function (type, key) {
    const foundItem = this[type].find((item) => item.key === `${key}`);

    return foundItem?.value ?? '';
};

const getLabelValueList = (list) => list.map((item) => ({
    label: item.value,
    value: item.key
}));

DomainData.prototype.getPrefixesLabelValueList = function () {
    return getLabelValueList(this.prefixes);
};

DomainData.prototype.getGenerationsLabelValueList = function () {
    return getLabelValueList(this.generations);
};

DomainData.prototype.getCountriesLabelValueList = function () {
    return getLabelValueList(this.countries);
};

DomainData.prototype.getHardRequiredFields = function (physicalCountry, mailingCountry, customerType) {
    const selectedList = this.allTaxIds.filter((row) => [
        row.countryCode === physicalCountry || row.countryCode === mailingCountry,
        row.customerType === customerType
    ].every((pass) => pass));

    return selectedList.filter((row) => row.hardRequired);
};

DomainData.prototype.getSoftRequiredFields = function (physicalCountry, mailingCountry, customerType) {
    return this.allTaxIds.filter((row) => [
        row.countryCode === physicalCountry || row.countryCode === mailingCountry,
        row.customerType === customerType
    ].every((pass) => pass));
};

DomainData.prototype.getUniquePrivacyPolicyCountries = function () {
    if (isFeatureToggled('F10879_US59461_GET_ALL_PRIVACY_POLICIES_FROM_API')) {
        return [...new Set(this.allPrivacyPolicies.map((item) => item.countryCode))];
    }
    return [
        'AU',
        'FJ',
        'NZ',
        'PG'
    ];
};
